import React from 'react';
import SliderComp from 'rc-slider';

import './Slider.scss';

const Slider = (props) => (
  <div className="slider-wrapper">
    <SliderComp {...props} />
  </div>
);

Slider.propTypes = {};

export default Slider;
